/** @jsxImportSource @emotion/react */

import { useState } from 'react'
import Typography from '@mui/material/Typography'
import { createSearchParams, useLocation, useSearchParams } from 'react-router-dom'
import { RouteValue, useLink } from 'routes/cmsRoutes'
import { TabsItem } from 'types/tabsItem'
import TabsNavigation from 'components/TabsNavigation'
import { findAllPlatforms_findAllPlatforms_items as Platform } from '__generatedTypes__/findAllPlatforms'
import withPlatformCheck from 'HOCs/withPlatformCheck'
import { FaqPages } from '__generatedTypes__/globalTypes'
import FAQ from 'pagesNew/FAQ'
import NotFound from 'components/NotFound'
import { PlatformSlug } from 'constants/consts'
import { isStudyScheduleAvailable } from '../platformConfig'
import { List } from '../List'
import { Schedule } from '../Schedule'
import * as classes from './styles'

export { isStudyScheduleAvailable } from '../platformConfig'

export const STUDY_SCHEDULE_TASKS_TAB = {
  id: 'study-schedule-tasks',
  title: 'Tasks',
}

export const STUDY_SCHEDULE_TAB = {
  id: 'study-schedule-tab',
  title: 'Schedule',
}

export const STUDY_SCHEDULE_FAQ_TAB = {
  id: 'study-schedule-faq',
  title: 'FAQ',
}

export const TABS = [STUDY_SCHEDULE_TASKS_TAB, STUDY_SCHEDULE_TAB, STUDY_SCHEDULE_FAQ_TAB]

export const QUERY_PARAM = 'tab'

type Props = {
  platform: Platform
}

export const StudyScheduleTabs = withPlatformCheck(({ platform }: Props) => {
  if (!isStudyScheduleAvailable(platform.slug as PlatformSlug)) {
    return <NotFound />
  }

  const location = useLocation()
  const { navigate } = useLink()
  const [searchParams] = useSearchParams()

  const [activeTab, setActiveTab] = useState<TabsItem>(() => {
    const tabId = searchParams.get(QUERY_PARAM)

    return TABS.find(({ id }) => id === tabId) || STUDY_SCHEDULE_TASKS_TAB
  })

  const handleChangeTab = (activeTab: TabsItem) => {
    navigate(location.pathname as RouteValue, undefined, {
      searchParams: createSearchParams({ [QUERY_PARAM]: activeTab.id }),
    })
    setActiveTab(activeTab)
  }

  const renderTab = () => {
    if (activeTab.id === STUDY_SCHEDULE_TASKS_TAB.id) {
      return <List platformId={platform.id} />
    }

    if (activeTab.id === STUDY_SCHEDULE_TAB.id) {
      return <Schedule platformId={platform.id} />
    }

    if (activeTab.id === STUDY_SCHEDULE_FAQ_TAB.id) {
      return <FAQ css={classes.faq} page={FaqPages.CustomScheduler} />
    }

    return null
  }

  return (
    <section css={classes.container}>
      <Typography css={classes.header} variant="title3">
        Custom Scheduler
      </Typography>

      <TabsNavigation css={classes.tabs} tabs={TABS} value={activeTab} onChange={handleChangeTab} />

      {renderTab()}
    </section>
  )
})
